import React, { useState } from "react";
import { Container, Row, Col, Modal, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const SemSettings = props => {
  //meta title
  document.title = "SEMs Settings";
  const { getRequest, postRequest } = useRequests();

  
  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    setFormData2({ 
      ...formData2, 
      sem_id: elementData.sem_id,
      status: elementData.status
    });
    setStandardModal2(true);
  }

  const [formData2, setFormData2] = React.useState({
		sem_id: '',
		status: '',
	});
  const handleSubmit2 = async () => {
    try {
      let submit1 = document.getElementById('submit2');
      submit1.disabled = true;
      submit1.textContent = 'Processing...';

      const jsonpar = JSON.stringify({
        sem_id: formData2.sem_id,
        status: formData2.status
      });
      const res = await postRequest('update-sem-status', jsonpar);
      if (res && res.code === 200) {
        handleLoadGetSEMData();

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'success',
          message: res.message,
        }));
      }
      else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
      resetAlertData();

      submit1.disabled = false;
      submit1.textContent = 'Update';

      setStandardModal2(false);
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    validation1.setValues({
      ...validation1.values,
      sem_id: elementData.sem_id,
      field_name: elementData.field_name,
      field_value: elementData.field_value
    });
    setStandardModal1(true);
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      sem_id: '',
      field_name: '',
      field_value: '',
    },
    validationSchema: Yup.object({
      field_value: Yup.string().required('Value is required')
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          sem_id: values.sem_id,
          field_value: values.field_value
        });
        const res = await postRequest('update-sem-data', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetSEMData();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [SEMSettingsTBody, setSEMSettingsTBody] = React.useState('');
  const handleLoadGetSEMData = async () => {
    const res = await getRequest('get-sem-data');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempTBody = originalText.map((element, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{element.field_name}</td>
          <td><Link to="#">{element.field_value}</Link></td>
          <td>
            <span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span>
          </td>
          <td className="text-center">
            <div className="centerLink">
              <span title="Edit Status" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></span>
              <span title="Edit SEMs Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="bx bxs-edit"></i></span>
            </div>
          </td>
        </tr>
      ));

      setSEMSettingsTBody(tempTBody);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setSEMSettingsTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetSEMData();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("SEMs Settings")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0" >
                      <table className="table table-hover table-highlight" style={{minWidth: '900px'}}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Value</th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {SEMSettingsTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal centered backdrop="static" isOpen={StandardModal2}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">SEMs Setting</h5>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Status : </Label>
              <select className="form-select" name="status" value={formData2.status} onChange={(e) => setFormData2({ ...formData2, status: e.target.value })}>
                <option value="Enable">Enable</option>
                <option value="Disable">Disable</option>
              </select>
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit2"
            onClick={(e) => {
              e.preventDefault();
              handleSubmit2();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>

      <Modal centered backdrop="static" isOpen={StandardModal1}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">SEMs Setting</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">{validation1.values.field_name}</Label>
              <Input name="field_value" type="text" placeholder="Enter URL"
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                value={validation1.values.field_value || ""}
                invalid={
                  validation1.touched.field_value && validation1.errors.field_value ? true : false
                }
              />
              {validation1.touched.field_value && validation1.errors.field_value ? (
                <FormFeedback type="invalid">{validation1.errors.field_value}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit1"
            onClick={(e) => {
              e.preventDefault();
              validation1.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(SemSettings);
